import Cookies from 'js-cookie';
const cookie = Cookies.withConverter({
    read: decodeURIComponent,
    write: encodeURIComponent,
});

const NAME = 'bucket';

function assertName(name) {
    if (typeof name != 'string') {
        throw new TypeError('`name` must be a string');
    }
}

export default {
    name: 'bucketcookieservice',
    dependencies: [],
    callable() {
        return {
            get(name) {
                assertName(name);

                const cookieValue = cookie.get(NAME);
                if (cookieValue) {
                    try {
                        // This uses an array instead of an object to match the backend
                        const array = JSON.parse(cookieValue);
                        // eslint-disable-next-line no-cond-assign
                        for (let i = 0, item; (item = array[i]); i++) {
                            if (item.name === name) {
                                return item.value;
                            }
                        }
                    } catch (e) {
                        this._deleteAndThrow();
                    }
                }

                return null;
            },

            set(name, value, expires = null) {
                assertName(name);

                if (expires !== null) {
                    throw Error('`expires` is not implemented');
                }

                let array;
                const cookieValue = cookie.get(NAME);
                if (cookieValue) {
                    try {
                        // This uses an array instead of an object to match the backend
                        array = JSON.parse(cookieValue);

                        // FIXME: Should use `find`
                        const exists = array.some(item => {
                            if (item.name === name) {
                                item.value = value;
                                return true;
                            }
                            return false;
                        });

                        if (!exists) {
                            array.push({ name, value });
                        }
                    } catch (e) {
                        this._deleteAndThrow();
                    }
                } else {
                    array = [{ name, value }];
                }

                cookie.set(NAME, JSON.stringify(array), {
                    expires: 365,
                });
            },

            delete(name) {
                assertName(name);

                const cookieValue = cookie.get(NAME);
                if (cookieValue) {
                    try {
                        // This uses an array instead of an object to match the backend
                        const array = JSON.parse(cookieValue);
                        const filtered = array.filter(
                            item => item.name !== name
                        );
                        cookie.set(NAME, JSON.stringify(filtered), {
                            expires: 365,
                        });
                        return true;
                    } catch (e) {
                        this._deleteAndThrow();
                    }
                }

                return false;
            },

            _deleteAndThrow() {
                cookie.remove(NAME);
                throw Error('The cookie value cannot be parsed');
            },
        };
    },
};



// WEBPACK FOOTER //
// ./services/bucketCookie.js